import { cx } from "@emotion/css";
import { ChangeEventHandler } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createSearchInputStyles } from "./createSearchInputStyles";
import { ReactComponent as SearchIcon } from "./search-icon.svg";

interface SearchInputProps {
  id: string;
  className?: string;
  inputWrapperClassName?: string;
  placeholder?: string;
  value?: string;
  onChange: ChangeEventHandler;
}

export const SearchInput = ({
  className,
  inputWrapperClassName,
  id,
  value = "",
  placeholder = "",
  onChange,
}: SearchInputProps) => {
  const classes = createSearchInputStyles(useTheme());

  return (
    <div className={cx(classes.root, className)}>
      <div className={cx(classes.inputWrapper, inputWrapperClassName)}>
        <div className={classes.iconWrapper}>
          <SearchIcon />
        </div>
        <input
          id={id}
          onChange={onChange}
          type="text"
          className={classes.input}
          value={value}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
